// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__1iy8_","modal":"modal_modal__1DF1f","header":"modal_header__2iX3r","content":"modal_content__1tQ-X","actions":"modal_actions__2_2P4"};